import React from 'react'
import { compose, pure } from 'recompose'
import styles from './pageWrapperComponent.scss'
import PropTypes from 'prop-types'
export function PageWrapper (props: Props) {
  return (
    <main id='content' className={styles.mainContentWrapper}>
      {props.heroImage && (
        <img
          className={styles.heroImage}
          src={props.heroImage}
          alt={props.heroAlt}
        />
      )}
      {props.children}
    </main>
  )
}
PageWrapper.propTypes = {
  children: PropTypes.any,
  heroImage: PropTypes.any,
  heroAlt: PropTypes.string
}

export default compose(pure)(PageWrapper)



// WEBPACK FOOTER //
// ./src/components/pageWrapper/pageWrapperComponent.js